import { Component, Directive } from "@angular/core";

@Directive({
  selector: '[appFieldSuffix]'
})
export class FieldSuffixItemDirective {

}
